import { GenericStencil } from "@brexhq/metal-generic-stencil";
import * as React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { SingleFlexContainer } from "@brexhq/next/src/components/modules/LeadForm/Steps/GTMSteps/elements";

export const LoadingStencil = () => (
  <Container
    width="100%"
    display="flex"
    gap="sml"
    direction="column"
    margin={{
      LRG: [0, 0, "sml", 0],
      MED: [0, 0, "sml", 0],
      SML: [0, 0, "sml", 0],
    }}
  >
    <GenericStencil width="70%" height={30} />
    <Container
      width="100%"
      display="flex"
      direction={{
        LRG: "row",
        SML: "column",
      }}
      gap="sml"
    >
      <SingleFlexContainer>
        <GenericStencil width="100%" height={44} />
      </SingleFlexContainer>
      <SingleFlexContainer>
        <GenericStencil width="100%" height={44} />
      </SingleFlexContainer>
    </Container>
    <GenericStencil width="30%" height={20} />
    <GenericStencil width="100%" height={44} />
    <GenericStencil width="30%" height={20} />
    <GenericStencil width="100%" height={44} />
    <GenericStencil width="30%" height={20} />
    <Container
      width="100%"
      display="flex"
      direction={{
        LRG: "row",
        SML: "column",
      }}
      gap="sml"
    >
      <GenericStencil width="30%" height={44} />
      <GenericStencil width="70%" height={44} />
    </Container>
  </Container>
);
